const simpleFormat = text => `<p>${
  text.replace(/\r\n?/g, '\n').trim()
  .replace(/\n\n+/g, '</p><p>')
  .replace(/\n/g, '<br />')
}</p>`

export default simpleFormat
